// extracted by mini-css-extract-plugin
export default {"BannerImg":"BannerImg_BannerImg__KGaAu"};